import React, { useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faPowerOff } from "@fortawesome/free-solid-svg-icons";
import ZoneFilers from "views/pages/zoning/filters";
import CommonTable from "views/lib/components/CommonTable";
import CreateNewZone from "views/pages/zoning/create-new-zone";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { getZoneList, addZone } from "actions/zone/actions";

const Zoning = ({
                  zoneList,
                  getZoneList,
                  addZone,
                  closeCustomModal,
                  openCustomModal
                }) => {
  const handleEdit = useCallback(currentZone => {
    const modalObj = {
      modalSettings: {
        size: "md",
        style: {
          top: 20,
          width: "calc(100% - 40px)",
        }
      },
      header: "Edit Zone",
      children: (
        <CreateNewZone
          onCancel={() => closeCustomModal(modalObj)}
          currentZone={currentZone}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  }, [openCustomModal, closeCustomModal]);

  const handleEndNow = useCallback(currentZone => {
    currentZone.end = moment()
      .valueOf();
    addZone(currentZone);
  }, [addZone]);

  const getColumns = () => [
    {
      id: "name",
      Header: "Name",
      accessor: "name",
    },
    {
      id: "description",
      Header: "Description",
      accessor: "description",
      Cell: ({ original }) => original.description,
      style: {
        whiteSpace: "unset"
      }
    },
    {
      id: "radius",
      Header: "Radius",
      accessor: "radius",
      Cell: ({ original }) => `${original.radius}m`
    },
    {
      id: "bonus",
      Header: "Bonus",
      accessor: "bonus",
    },
    {
      id: "end",
      Header: "End",
      accessor: "end",
      Cell: ({ original }) => moment(original.end)
        .format("HH:mm YYYY-MM-DD")
    },
    {
      id: "type",
      Header: "Zone Type",
      accessor: "type",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div style={{
          width: 20,
          height: 20,
          backgroundColor: `${original.type}`
        }}/>
      )
    },
    {
      id: "actions",
      Header: "Actions",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div className="d-flex justify-content-around">
          <button
            className="btn btn-sm btn-warning"
            onClick={() => handleEdit(original)}
          >
            <FontAwesomeIcon icon={faPencilAlt}/>
          </button>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => handleEndNow(original)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger">
              <FontAwesomeIcon icon={faPowerOff}/>
            </button>
          </Popconfirm>
        </div>
      ),
      headerClassName: "text-center",
      className: "text-center"
    }
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={zoneList}
      getListFunction={getZoneList}
      FiltersComponent={ZoneFilers}
      searchHookProps={{
        size: 20,
        sort: "end,desc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  zoneList: state.zone.zoneList,
});

const mapStateToDispatch = dispatch => ({
  getZoneList: bindActionCreators(getZoneList, dispatch),
  addZone: bindActionCreators(addZone, dispatch),
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Zoning);



// WEBPACK FOOTER //
// ./src/views/pages/zoning/index.js